<template>
    <div class="modal-open">
        <div class="modal modal-opened" tabindex="-1" role="dialog" aria-hidden="false">
            <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
                <div class="modal-content modal-rounded">
                    <div class="row">
                        <div class="col-md-12">
                            <h1 class="page-title-error text-center"><span>404</span></h1>
                            <h2 class="page-subtitle-error text-center">{{'settings.page_not_found' | trans}}</h2>
                            <p class="text-center">{{'settings.page_not_found_subscription' | trans}}</p>
                            <div class="buttons text-center">
                                <router-link class="btn btn-outline-light mr-2 mb-md-0 mb-3" :to="{name: 'default'}">{{'home.labels.home' | trans}}</router-link>
                                <a class="btn btn-outline-light" href="https://autismtech.online/contacts">{{'validation.attributes.contacts' | trans}}</a>
                            </div>
                        </div>
                        <div class="col-md-12 text-center mt-3">
                            <img src="../../../assets/images/loader.gif" width="50px" alt="loader">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {

      };
    },
    computed: {
      ...mapGetters('auth', [
        'isGuest',
      ]),
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/error/components/ErrorModal.vue